"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Navigator = _interopRequireDefault(require("../App/Navigator.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An abstraction of Material UI's `Button`
 */
class Button extends _react.default.PureComponent {
  /**
   * Clicked.
   * 
   * @return {void}
   */
  handleClick = () => {
    const uri = this.props.uri;
    if (uri) _Navigator.default.navigate(uri);else this.props.onClick?.(this.props.value, this.props.name);
  };
  /**
   * Render.
   *
   * @return {ReactNode}
   */

  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: this.props.className,
      color: this.props.color,
      disabled: this.props.disabled || this.props.loading,
      endIcon: this.props.endIcon ? _ReactUtils.default.render(this.props.endIcon) : undefined,
      onClick: this.handleClick,
      size: this.props.size,
      startIcon: this.props.startIcon ? _ReactUtils.default.render(this.props.startIcon) : undefined,
      type: this.props.type,
      variant: this.props.variant,
      ...this.props.ButtonProps,
      children: this.props.label
    });
  }

  static propTypes = {
    ButtonProps: _propTypes.default.object,
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary", "default", "inherit"]),
    disabled: _propTypes.default.bool,
    endIcon: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.node]),
    label: _propTypes.default.string,
    loading: _propTypes.default.bool,
    name: _propTypes.default.string,
    onClick: _propTypes.default.func,
    size: _propTypes.default.oneOf(["small", "medium", "large"]),
    startIcon: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.node]),
    type: _propTypes.default.string,
    uri: _propTypes.default.string,
    value: _propTypes.default.any,
    variant: _propTypes.default.oneOf(["text", "outlined", "contained"])
  };
  static defaultProps = {
    color: "primary",
    size: "medium",
    variant: "outlined"
  };
}

var _default = Button;
exports.default = _default;